import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
export var observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();